<p>
	CIFRIS23 is an international event, supported and organized by De Cifris, aimed at bringing together researchers in
	the field of cryptography, practitioners, developers, and users to foster cooperation and exchange techniques,
	tools, experiences, and ideas.
</p>
<p>
	The first morning is reserved to institutional and industrial stakeholders operating in the field of cryptography
	and cyber security. The first and second afternoon constitute the Scientific Session of the event, where scientific
	talks take place. The second morning hosts six related workshops.
</p>
<p>
	Scientific talks consists of a selection of:
</p>
<ul>
	<li>
		Invited talks and
	</li>
	<li>
		Contributed talks selected from the submitted papers by the Chairs and the Programme Committee.
	</li>
</ul>

<h4> INVITED SPEAKERS </h4>
<ul>
	<li>
		<b>Svetla Petkova-Nikova</b> (Katholieke Universiteit Leuven- Belgium)
	</li>
	<li>
		<b>Antoine Joux</b> (CISPA - Germany)
	</li>
	<li>
		<b>Massimo Giulietti</b> (University of Perugia - Italy)
	</li>
</ul>

<h4> ORGANIZATION </h4>
<h5> Institution </h5>
<p>
	The “De Componendis Cifris Associazione di Promozione Sociale” (De Cifris) is a non-profit scientific organization
	whose purpose is to spread cryptography in all its aspects, from theoretical foundations, applications to historical
	evolution and impact on society, and to facilitate the aggregation of scholars and researchers, so that from their
	collaboration project ideas and initiatives of scientific interest can rise.
</p>
<h5> Organizing Committee </h5>
<ul>
	<li>
		Roberto Civino (University of L’Aquila - Italy)
	</li>
	<li>
		Daniele Friolo ("Sapienza" University of Rome - Italy)
	</li>
	<li>
		Massimiliano Sala (University of Trento -Italy)
	</li>
</ul>
<h5> Chairs of the Scientific Session </h5>
<ul>
	<li>
		Sihem Mesnager (University of Paris VIII - France)
	</li>
	<li>
		Michele Ciampi (University of Edimburgh - UK)
	</li>
</ul>

<h4>LOCATION</h4>
<p>
	The conference is held at <a target="_blank" href="https://www.consob.it/">CONSOB</a> headoffice, Via Giovanni
	Battista Martini, 3 - 00198 Rome (Italy).
</p>
<p>
	For more info, please chek our other web pages or contact <a href="mailto:cifris23@decifris.it">
		cifris23&#64;decifris.it</a>.
</p>